import React, { useState, useEffect } from 'react';
import { Card, Form } from '@deere/ux.uxframe-react'
import RadioGroup from '../../components/RadioGroup';
import { updateSurveyAnswers } from '../../redux/action/surveyAction';
import { findAnswerIndex, updateAnswerInArray, getTranslation, getAnswerLabel } from '../../utils/utils';
import store from '../../redux/store'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import {  LABOR_ERR_MSG, EMPTY_BODY, SCBM_SECCIO_CODES } from '../../utils/surveyLiterals'
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';

export default function LaborSegmentationPage({ survey,  countryList}) {
    const { t } = useTranslation();
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([])
    const dispatch = useDispatch()
    const [checkSection, setCheckSection] = useState("")
        
    const section = survey.sections.find(e => e.code === SCBM_SECCIO_CODES.LB && e.active);    
    const questions = section && section.questions ? section.questions : null 

    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers])                    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyResponse])

    if (questions === null) { return <div><p>{LABOR_ERR_MSG}</p></div> }
    

    if(!survey){
        return EMPTY_BODY;
    }  

    const updateAnswer = (e, questionId) => {
        updateAnswerInArray(questionId, answers, e.target ? e.target.value : e);
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function createDependencyTextArea(question) {
        if (question && question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);  
            if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                return <> 
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <DebounceInput
                        element="textarea"
                        required={!checkSection}
                        className="form-control"
                        onChange={(e) => updateAnswer(e,question.id)}
                        debounceTimeout={300}
                        value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                        name={`${getTranslation(section, 'description')}-${question.id}`}/>
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                    </>
            }
        }
        return null;
    }

    function createRadioSection(question) {
       return <>
               <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <div><RadioGroup key={question.id} rgIndex={question.rgIndex} radioLabels={question ? question.selections : []}
                        updateAnswer={updateAnswer} question={question}
                        defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                        section={getTranslation(section, 'description')}
                        checkedProprietary={checkSection}/>
                    </div>                        
                </Form.Group>
            </>
    }   
    function createOption(question){
        if (question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                return <>
                    <Form.Group>
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                            <Form.Control as='select' required={!checkSection} className="custom-select" onChange={(e) => updateAnswer(e, question.id)}
                            value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                            name={getTranslation(section, 'description')+'-'+question.id}>
                            <option value=''>{t('lbl_dropdown_select')}</option>
                            {question.selections ? question.selections.sort((a, b) => (parseInt(a.value) > parseInt(b.value)) ? 1 : -1).map(opt => <option key={opt.id} value={opt.value}>{getTranslation(opt, 'text')}</option>) : null}
                        </Form.Control>
                        <div className="invalid-feedback">
                            {t('bs_required')}
                        </div>
                        </Form.Group>
                     </>
            }
        }
    }
    function createDateSection(question) {
        const answerLabel = getAnswerLabel(question, answers);
        if (question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                return(
                        <Form.Group>
                        <Form.Label className="uxf-label">
                                {getTranslation(question, 'text')}
                        </Form.Label>
                        <Form.Control type="date" required id={question.id}
                            data-testid={question.id}
                            defaultValue={answerLabel ? answerLabel: ''}
                            onChange={e => updateAnswer(e, question.id)}
                            name={`${getTranslation(section, 'description')}-${question.id}`}
                        />
                        <div className="invalid-feedback">{t('bs_required')}</div>
                    </Form.Group>)
            }
        }
    } 

    function createCountrySection(question) { //agrehar loading cuando lista es 0
        let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
        if (countryList && countryList.length > 0) {
            const indx = findAnswerIndex(question.id, answers);
            const answer = indx >= 0 ? answers[indx].answer : -1;
            
            if (question.idQuestionDepends) {
                if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                    return (     
                            <Form.Group sx={{ m: 3 }} variant="standard">
                                <Form.Label className="uxf-label">
                                    {getTranslation(question, 'text')}
                                </Form.Label>
                                <Form.Control as='select'
                                className="custom-select"
                                    id={`${getTranslation(section, 'description')}-${question.id}`}
                                    key="originCountry"
                                    required    
                                    size="small"
                                    value={answer < 0?'':answer}
                                    onChange={(e) => { updateAnswer(e.target.value, question.id, true); }
                                    }
                                >
                                    <option value=''>{t('lbl_dropdown_select')}</option>
                                    {countryList ? countryList.sort((a, b) => (a.name > b.name) ? 1 : -1).map(opt => <option key={opt.iso2CountryCode} value={opt.name}>{opt.name}</option>) : null}
                                </Form.Control>
                                <div className="invalid-feedback">{t('bs_required')}</div>
                            </Form.Group>
                    );
                }                
            }
        }
        else {
            if(!countryList){
                if (question.idQuestionDepends){
                    if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                        return (
                            <>
                                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                                <br></br>
                                <Form.Label>{'Loading...'}</Form.Label>
                            </>
                        )
                    }
                }
            }else{
                if (question.idQuestionDepends){
                    if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                        return (
                            <>
                                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                                <br></br>
                                <Form.Label>{t('tps_country_not_found')}</Form.Label>
                            </>
                        );
                    }
                }
            }
        }
    }



    if (survey === null) { return <></> }
    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}                    
                </Card.Title>                                             
                <>
                    {
                        <>
                            {            
                                questions.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((q,index) =>

                                    <div key={index}>
                                        <Form.Row className={q.idQuestionDepends ? 'd-block mb-4 pl-4' : "d-block mb-4"}>
                                            {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                                            {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createDependencyTextArea(q) : <></>}
                                            {q.type === 'OPTION' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createOption(q) : <></>}
                                            {q.type === 'DATE' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createDateSection(q) : <></>}
                                            {q.type === 'OPTION_CTY' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCountrySection(q) : <></>}
                                        </Form.Row>
                                    </div>
                                )
                            }
                        </>
                    }
                </>
            </Card.Body>
        </Card>        
    </>)
}
